import searchReducer from "./reducers";
export { default as Search } from "./SearchComponent";
export default searchReducer;
